import { useContext, useEffect, useState } from "react";
import TenantContext from "../../../context/tenant/TenantContext";
import TenantProvideDocumentNew from "../../../pages/tenant/tenant-home/TenantProvideDocumentNew";
import { useParams } from "react-router-dom";
import { haveValue } from "../../../helper/common";

const GuarantorProvideDocs = () => {
  const { guarantorId = null } = useParams();
  const { getGuarantorDetailsWithEmail, guarantorAddedDetails } =
    useContext(TenantContext);
  const [guarantorData, setGuarantorData] = useState({});

  useEffect(() => {
    if (haveValue(guarantorId)) {
      guarantorAddedDetails(guarantorId)
        .then((res) => {
          loadGuarantorData(res.success_res?.gurantor_email);
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      loadGuarantorData();
    }
  }, []);

  const loadGuarantorData = (email = null) => {
    getGuarantorDetailsWithEmail(email)
      .then((res) => {
        setGuarantorData(res.guarantorData);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  console.log(guarantorData, "guarantorDataguarantorData");

  return (
    <>
      <TenantProvideDocumentNew
        guarantor={true}
        user={guarantorData}
        fetchGuarantorDetails={loadGuarantorData}
      />
    </>
  );
};

export default GuarantorProvideDocs;
